<template>
    <div class="img-box" @click="handleClick">
        <div v-if="loading && showLoadingImg" class="loading-box">
            <div class="mg-loading"></div>
        </div>
        <div v-if="showLock" @click.stop="register" class="lock-img-for-ads">
            <div class="lock-box">
                <i class="iconfont icon-lock1"></i>
            </div>
        </div>
        <div class="img-content" :class="{ 'blur-for-ads': showLock }" :style="{ zIndex: loading ? '-1' : '0' }">
            <site-img
                :src="src"
                type="img"
                :dir="dir"
                :size="size"
                :alt="alt"
                :rate="rate"
                :persent="persent"
                :errorImg="errorImg"
                @update="imgUpdate"
                @load="imgLoad($event)"
                @error="imgError"
                :lazy="lazy"
            />
        </div>
        <slot></slot>
    </div>
</template>

<script>
import util from '@/common/util';
export default {
    emits: ['load', 'error'],
    props: {
        src: {
            validator: function(value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            required: true,
            default: ''
        },
        dir: {
            type: String,
            default: 'width'
        },
        size: {
            type: Number,
            default: 0
        },
        rate: {
            type: Number,
            default: 2
        },
        persent: {
            type: Number,
            default: 0
        },
        alt: {
            type: String,
            default: ''
        },
        lazy: {
            type: Boolean,
            default: undefined
        },
        showLoadingImg: {
            type: Boolean,
            default: true
        },
        errorImg: {
            type: String,
            default: ''
        },
        showLock: {
            type: Boolean,
            default: false
        },
        isLockImgForAds: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            loading: util.isClient
        };
    },
    inject: {
        noImgLazy: { default: false }
    },
    created() {
        if (this.noImgLazy || this.platform.isScreenshot || !util.isClient) {
            this.loading = false;
        }
    },
    methods: {
        imgUpdate() {
            if (util.isClient && !this.platform.isScreenshot) {
                this.loading = true;
            }
        },
        imgLoad($event) {
            this.loading = false;
            this.$emit('load', $event);
        },
        imgError($event) {
            this.$emit('error', $event);
        },
        async register() {
            const signLog = (await import('@/components/sign-log')).default;
            signLog.register({
                allowClose: false,
                onregister: (user, inquiry) => {
                    return false;
                },
                onsuccess: () => {
                    return false;
                }
            }, 'adNewRegister');
        },
        handleClick(event) {
            if (this.isLockImgForAds) {
                this.register();
                event.stopPropagation();
                event.preventDefault();
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../theme/mixin.scss';

.img-box {
    position: relative;
    overflow: hidden;
    .lock-img-for-ads {
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
        z-index: 12;
        .lock-box {
            position: absolute;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .iconfont {
                font-size: 24px;
            }
            &:hover {
                .iconfont {
                    color: var(--color-theme);
                }
            }
        }
    }

    .loading-box {
        position: absolute;
        background-color: #ffffff;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .img-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        > img {
            width: 100%;
            height: 100%;
            @include object-fit(cover);
        }

        &.blur-for-ads {
            filter: blur(6px);
        }
    }
}
</style>
